import { WorkloadReliabilityMetricsItem } from 'features/cost-report/types/workloadsReliability';

import { ReliabilityWorkloadsTable } from './_components/ReliabilityWorkloadsTable';

import { Box } from '@cast/design-system';

type ReliabilityWorkloadsSectionProps = {
  cacheKey: string;
  disableWorkloadLink?: boolean;
  getWorkloadLink?: (workload: WorkloadReliabilityMetricsItem) => string;
};

export const ReliabilityWorkloadsSection = ({
  cacheKey,
  disableWorkloadLink,
  getWorkloadLink,
}: ReliabilityWorkloadsSectionProps) => {
  return (
    <Box flexGrow={1}>
      <ReliabilityWorkloadsTable
        cacheKey={cacheKey}
        disableWorkloadLink={disableWorkloadLink}
        getWorkloadLink={getWorkloadLink}
      />
    </Box>
  );
};
